import React from 'react';
import { JiraConversationAssistant } from '@atlassian/jira-conversation-assistant/src/ui/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useRovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';

/**
 * Rendering JiraConversationAssistant without its UI to initialize the Global Rovo Store.
 * This component is conditionally rendered based on iframe status, Rovo entitlement, and feature flag.
 */
export const RovoStoreInitializer = () => {
	// Check if app is being loaded in iFrame
	// We don't want to render the Rovo Chat wrapper if in iFrame
	const isIframe = typeof window !== 'undefined' && window.self !== window.top;
	const rovoEntitlement = useRovoEntitlementResource();
	const isRovoLLMEnabled = !!rovoEntitlement?.data?.isRovoLLMEnabled;

	if (isIframe || !isRovoLLMEnabled || !fg('rovo-bridge-integration-jira')) {
		return null;
	}

	return (
		<JiraConversationAssistant
			onClosePanel={() => {
				/* empty */
			}}
		>
			<></>
		</JiraConversationAssistant>
	);
};

RovoStoreInitializer.displayName = 'RovoStoreInitializer';
